import { useQuery } from '@tanstack/react-query'

import { QUERY_KEY } from '../constants'

import { checkLogin } from '../api/auth'
import { getUserInfo } from '../api/my'

interface UseUserInfoProps {
  enabled?: boolean
}

/**
 * 서버로부터 로그인 상태인지 확인하거나 유저 정보를 불러오는 tanstack-query hook
 * @param props UserUserInfoProps
 * @returns UseQueryResult & { isLogin: boolean, isCheckingLogin: boolean, refetchCheckLogin: (options?: RefetchOptions) => Promise<QueryObserverResult<boolean, Error>> }
 */
export function useUserInfo(props?: UseUserInfoProps) {
  // 서버에서 로그인 상태를 확인하는 쿼리
  const checkLoginQuery = useQuery({
    queryKey: [QUERY_KEY.checkLogin],
    queryFn: checkLogin,
    staleTime: 5 * 60 * 1000, // 5분 동안 fresh
    gcTime: 10 * 60 * 1000, // 10분 동안 캐싱
  })

  // 유저 정보 쿼리
  const userInfoQuery = useQuery({
    queryKey: [QUERY_KEY.userInfo],
    queryFn: getUserInfo,
    // checkLoginQuery가 성공하고 (data가 true이고) 있을 때만 getUserInfo를 호출
    enabled: !!checkLoginQuery.data || !!props?.enabled,
    staleTime: 1 * 60 * 1000, // 1분 동안 fresh
    gcTime: 5 * 60 * 1000, // 5분 동안 캐싱
  })

  return {
    ...userInfoQuery,
    isLogin: !!checkLoginQuery.data, // checkLoginQuery의 data가 있으면 로그인 상태로 간주
    isCheckingLogin: checkLoginQuery.isLoading, // 로그인 상태 확인 중인지 여부
    refetchCheckLogin: checkLoginQuery.refetch, // checkLogin refetch
  }
}
